import { useCallback, useContext, useEffect, useState } from 'react';
import { useParams, generatePath, useNavigate } from 'react-router-dom';
import Api from 'domain/api';
import { getNestedCategory } from 'domain/categories/helpers';
import CompanyWorkspaceContext from 'pages/company/WorkspaceRoute/CompanyWorkspaceContext';
import ROUTES_PATH from 'domain/router/routesPathConfig';
import useQuery from 'hooks/useQuery';

const useFetchTotalByCategory = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const params = useParams();
  const query = useQuery();
  const category = getNestedCategory(params);
  const { category1 } = params;
  const { companyType } = useContext(CompanyWorkspaceContext);
  const isConfidential = companyType === 'confidential';

  const [total, setTotal] = useState(null);
  const [isBusy, setIsBusy] = useState(true);
  const [totalIsFetched, setTotalIsFetched] = useState(false);

  const fetchGridTotal = useCallback(async () => {
    setIsBusy(true);

    await Api.getWorkspaceGridTotalByCategory({
      params: {
        isConfidential,
        companyId,
        category,
        ...query,
      },
    })
      .then(({ data }) => {
        setTotal(data);
        setTotalIsFetched(true);
      })
      .finally(() => {
        setIsBusy(false);
      });
  }, [companyId, isConfidential, category, query]);

  useEffect(() => {
    fetchGridTotal().then();
  }, [fetchGridTotal]);

  useEffect(() => {
    // TODO(DA-19430 / grid ticket 6.1): when document-type tabs land in Grid view, add the same
    // empty-doctype-tab carve-out as the tile path (documents/sagas/index.js `success`): an empty
    // Fin/Gen tab (deepest segment = a tab id, total 0) must NOT bounce back to category1.
    // Grid has no tabs yet (WorkspaceDoctypeTabs suppresses itself in grid), so `category` is never
    // a tab id here today.
    if (total === 0 && category !== category1) {
      const route =
        companyType === 'confidential'
          ? ROUTES_PATH.COMPANY_CONFIDENTIAL_WORKSPACE.absolute
          : ROUTES_PATH.COMPANY_WORKSPACE.absolute;

      const path = generatePath(route, { companyId, category1 });

      navigate(path);
    }
  }, [total, companyType, navigate, category, category1, companyId]);

  return {
    documentsTotal: total,
    documentsTotalIsBusy: isBusy,
    documentsTotalIsFetched: totalIsFetched,
    fetchGridTotal,
  };
};

export default useFetchTotalByCategory;
